<template>
  <v-dialog v-model="active" persistent max-width="800">
    <v-card>
      <v-card-title v-if="value == 1"
        >Los pedidos confirmados no pueden ser modificados</v-card-title
      >
      <v-card-text class="pb-0">
        <v-row>
          <v-col cols="12" sm="12">
            <v-alert
              v-if="alertProduct(value, data.originalProducts) == 1"
              border="bottom"
              colored-border
              type="warning"
              elevation="0"
              class="grey--text text--darken-2 alert-verify"
            >
              Su pedido contiene artículos de
              <strong>disponibilidad baja</strong>, por favor facturar cuanto
              antes.
            </v-alert>
            <p v-if="value == undefined" class="headline">
              Detalle del Pedido: {{ data.sale_id }}
            </p>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-simple-table fixed-header height="50%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th class="text-left">Cantidad</th>
                    <th class="text-left">Descripción</th>
                    <th class="text-left">Precio Unitario Neto</th>
                    <th class="text-left">IVA %</th>
                    <th class="text-left">Subtotal</th>
                  </tr>
                </thead>
                <tbody v-if="value == undefined">
                  <tr v-for="(item, i) in items_details_cart(data)" :key="i">
                    <td class="weight-l">{{ item.sku }}</td>
                    <td class="weight-l">{{ item.quantity }}</td>
                    <td class="weight-l">{{ item.title }}</td>
                    <!-- <td class="weight-l">{{ item | pvc_detail | currency }}****</td> -->
                    <td class="weight-l">{{ item.pvc | currency }}</td>
                    <td class="weight-l">{{ item.iva }}</td>
                    <td class="weight-l">
                      {{ item.sub_pvc | currency }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="value == 1">
                  <tr v-for="(item, i) in data.products" :key="i">
                    <td class="weight-l">{{ item.sku }}</td>
                    <td class="weight-l">{{ item.quantity }}</td>
                    <td class="weight-l">{{ item.title }}</td>
                    <td class="weight-l">{{ pvc(item) | currency }}</td>
                    <td class="weight-l">{{ item.iva }}</td>
                    <td class="weight-l">{{ subtotal(item) | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <p
              v-if="value == undefined"
              class="text-right body-1 font-weight-bold pt-5"
            >
              Subtotal NETO: {{ data | subtotal_neto | currency }}
            </p>
            <p v-else class="text-right body-1 font-weight-bold pt-5">
              Subtotal NETO: {{ data.total | currency }}
            </p>
          </v-col>
        </v-row>
        <v-progress-linear
          v-if="progress"
          indeterminate
          color="#00BFA6"
        ></v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="value == 1"
          color="primary"
          dark
          @click="$emit('dialog:change', data)"
        >
          Confirmar
        </v-btn>
        <v-btn color="#b2aaaa" dark @click="$emit('dialog:change', 'cerrar')">{{
          value == 1 ? "editar" : "cerrar"
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["active", "data", "value"],
  data() {
    return {
      progress: false,
    };
  },
  filters: {
    subtotal_neto(value) {
      return value.sub_total;
    },
    pvc_detail(order) {
      let pvc = order?.pvc ? order.pvc : order.price;

      console.log("pvc", order);

      return pvc;
    },
  },
  computed: {
    itemsDiscount() {
      return this.$store.getters["auth/DISCOUNT_CLIENT"];
    },
  },
  methods: {
    subtotal_detail(order) {
      let price = order?.pvc ? order.pvc : order.price;
      return price * order.quantity;
    },

    pvc(order) {
      console.log("order", order);
      let pvc = order?.pvc ? order.pvc : order.price;

      let discount_product = this.Discount(pvc, order.discount, order.quantity);

      let total_pvc_product = pvc - discount_product;

      return total_pvc_product - total_pvc_product * (this.itemsDiscount / 100);
    },
    items_details_cart(products) {
      return products?.items ? products.items : products.sale_detail;
    },
    subtotal(order) {
      let pvc = order?.pvc ? order.pvc : order.price;
      // let data = parseInt(pvc) parseInt(order.quantity)

      let sub_total_product;
      let sub_total;
      if (order?.discount) {
        let discount_value = this.Discount(
          order.pvc,
          order.discount,
          order.quantity
        );
        sub_total_product =
          (parseFloat(pvc) - parseFloat(discount_value)) *
          parseInt(order.quantity);
        sub_total =
          sub_total_product - sub_total_product * (this.itemsDiscount / 100);
      } else {
        sub_total_product = parseFloat(pvc) * parseFloat(order.quantity);
        sub_total =
          sub_total_product - sub_total_product * (this.itemsDiscount / 100);
      }

      return sub_total;
    },
    Discount(pvc, discount, slider_product) {
      let pvc_total = 0;
      if (slider_product > 0) {
        pvc_total = pvc * (discount / 100);
      }
      return pvc_total;
    },
    alertProduct(value, data) {
      if (value == 1) {
        let array = data.map((index) => {
          return index.stock_text;
        });

        let very_low = array.includes("Disponibilidad Muy Baja");
        let low = array.includes("Disponibilidad Baja");

        if (low == true || very_low == true) {
          return 1;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
  },
};
</script>

<style>
.alert-verify {
  background: #80808012 !important;
  box-shadow: 0 2px 4px rgba(27, 31, 35, 0.15) !important;
}
</style>